// extracted by mini-css-extract-plugin
export default {"commitList":"CommitList_commitList__Ea-xZ","commitListTitle":"CommitList_commitListTitle__sAeWG","subtext":"CommitList_subtext__1IkTJ"};